<div [class.bg-violet-100]="aside$ | async" [class.dark:bg-[#252c5f]]="aside$ | async">

  <div class="w-full">

    <div class="mx-auto lg:mx-0 lg:max-w-none flex items-center justify-between border-b border-violet-200/50 dark:border-[#3c4377] p-6">
      <h2 class="text-lg text-secondary dark:text-white font-semibold">SalesOMMO Assistant</h2>
      <button type="button" (click)="closeAside()" class="hover:opacity-90">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5 text-secondary">
          <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
        </svg>
      </button>
    </div>

    <!-- Messages -->
    <div #messagesContainer @fadeFromRight class="space-y-6 p-6 overflow-y-scroll h-[calc(100vh-300px)] scrollbar-thin scrollbar-track-transparent scrollbar-thumb-violet-200 hover:scrollbar-thumb-transparent"> <!-- With Workspace: h-[calc(100vh-385px)] -->

      <div class="flex">
        <div class="w-10 lg:w-12 pr-3">
          <svg viewBox="0 0 24 24" class="text-indigo-300 group-hover:text-white h-8 w-8" fill="none">
            <g clip-path="url(#clip0_1642_2876)">
              <path d="M12.0005 0V3.37519C16.6652 3.37519 20.0445 6.68252 20.0445 11.9819C20.0445 17.2812 16.6652 20.6564 12.0005 20.6564V23.9981C18.6932 23.9981 23.9991 19.0362 23.9991 11.9828C24 4.96193 18.6941 0 12.0005 0Z" fill="#3B4377"/>
              <path d="M0 11.9819C0 19.0362 5.30593 23.9972 11.9967 23.9972V20.6555C7.33393 20.6555 3.95455 17.2803 3.95455 11.9809C3.95455 6.68159 7.33393 3.37426 11.9967 3.37426V0C5.30593 0 0 4.96193 0 11.9819Z" fill="url(#paint0_linear_1642_2876)"/>
              <path d="M12.0033 11.9995H24V11.9837C24 4.96193 18.6262 0 12.0033 0V11.9995Z" fill="url(#paint1_linear_1642_2876)"/>
              <path d="M12.0033 24V12.0005C5.38599 12.0005 0.0158378 16.954 0.00653076 24H12.0033Z" fill="url(#paint2_linear_1642_2876)"/>
            </g>
            <defs>
              <linearGradient id="paint0_linear_1642_2876" x1="5.99837" y1="23.9972" x2="5.99837" y2="0.195206" gradientUnits="userSpaceOnUse">
                <stop stop-color="#8D0DFF"/>
                <stop offset="1" stop-color="#141A5C"/>
              </linearGradient>
              <linearGradient id="paint1_linear_1642_2876" x1="23.5998" y1="2.40846" x2="-4.29446" y2="20.3449" gradientUnits="userSpaceOnUse">
                <stop stop-color="#8D0DFF"/>
                <stop offset="0.35" stop-color="#B8369C"/>
                <stop offset="0.67" stop-color="#DE5948"/>
                <stop offset="0.89" stop-color="#F56F14"/>
                <stop offset="1" stop-color="#FF7800"/>
              </linearGradient>
              <linearGradient id="paint2_linear_1642_2876" x1="26.7744" y1="7.34531" x2="-1.11894" y2="25.2808" gradientUnits="userSpaceOnUse">
                <stop stop-color="#8D0DFF"/>
                <stop offset="0.35" stop-color="#B8369C"/>
                <stop offset="0.67" stop-color="#DE5948"/>
                <stop offset="0.89" stop-color="#F56F14"/>
                <stop offset="1" stop-color="#FF7800"/>
              </linearGradient>
              <clipPath id="clip0_1642_2876">
                <rect width="24" height="24" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </div>

        <div class="bg-violet-500 w-72 rounded-lg shadow-lg shadow-violet-200 dark:shadow-none p-3">
            <p class="text-xs text-white/90">You are currently chatting with out AI-powered SalesOMMO Assistant. This state-of-the-art system is designed to provide quick repsonses to assist you efficiently. Fell fre to ask questions or seek guidance, and our assistent will do its best to help you navigate and find what you’re looking for.</p>
        </div>
      </div>

      <div *ngIf="messages.length > 0" @fadeFromRight>

        <div *ngFor="let message of messages; index as i;" class="pb-6">

          <div class="flex justify-end pb-3">
            <div class="bg-violet-200 max-w-72  inline-block rounded-lg shadow-lg shadow-violet-100 p-3">
              <p class="text-xs font-normal text-secondary">{{ message.prompt }}</p>
              <p *ngIf="message.timestamp" class="text-[10px] text-secondary/75 mt-1">{{ formatTimestamp(message.timestamp) }}</p>
            </div>

            <div class="w-10 h-10 lg:w-12 lg:h-12 pl-3">
              <img *ngIf="user" class="h-full w-full flex-none rounded-full" [src]="this.user.profile_photo || 'https://ui-avatars.com/api/?background=5046e5&color=fff&rounded=true&name='+this.user.name+'&format=svg&size=128'" (error)="onImageError($event)">
            </div>
          </div>

          <div class="flex">
            <div class="w-10 lg:w-12 pr-3">
              <svg viewBox="0 0 24 24" class="text-indigo-300 group-hover:text-white h-8 w-8" fill="none">
                <g clip-path="url(#clip0_1642_2876)">
                  <path d="M12.0005 0V3.37519C16.6652 3.37519 20.0445 6.68252 20.0445 11.9819C20.0445 17.2812 16.6652 20.6564 12.0005 20.6564V23.9981C18.6932 23.9981 23.9991 19.0362 23.9991 11.9828C24 4.96193 18.6941 0 12.0005 0Z" fill="#3B4377"/>
                  <path d="M0 11.9819C0 19.0362 5.30593 23.9972 11.9967 23.9972V20.6555C7.33393 20.6555 3.95455 17.2803 3.95455 11.9809C3.95455 6.68159 7.33393 3.37426 11.9967 3.37426V0C5.30593 0 0 4.96193 0 11.9819Z" fill="url(#paint0_linear_1642_2876)"/>
                  <path d="M12.0033 11.9995H24V11.9837C24 4.96193 18.6262 0 12.0033 0V11.9995Z" fill="url(#paint1_linear_1642_2876)"/>
                  <path d="M12.0033 24V12.0005C5.38599 12.0005 0.0158378 16.954 0.00653076 24H12.0033Z" fill="url(#paint2_linear_1642_2876)"/>
                </g>
                <defs>
                  <linearGradient id="paint0_linear_1642_2876" x1="5.99837" y1="23.9972" x2="5.99837" y2="0.195206" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#8D0DFF"/>
                    <stop offset="1" stop-color="#141A5C"/>
                  </linearGradient>
                  <linearGradient id="paint1_linear_1642_2876" x1="23.5998" y1="2.40846" x2="-4.29446" y2="20.3449" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#8D0DFF"/>
                    <stop offset="0.35" stop-color="#B8369C"/>
                    <stop offset="0.67" stop-color="#DE5948"/>
                    <stop offset="0.89" stop-color="#F56F14"/>
                    <stop offset="1" stop-color="#FF7800"/>
                  </linearGradient>
                  <linearGradient id="paint2_linear_1642_2876" x1="26.7744" y1="7.34531" x2="-1.11894" y2="25.2808" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#8D0DFF"/>
                    <stop offset="0.35" stop-color="#B8369C"/>
                    <stop offset="0.67" stop-color="#DE5948"/>
                    <stop offset="0.89" stop-color="#F56F14"/>
                    <stop offset="1" stop-color="#FF7800"/>
                  </linearGradient>
                  <clipPath id="clip0_1642_2876">
                    <rect width="24" height="24" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </div>

            <div class="bg-violet-500 w-72 rounded-lg shadow-lg shadow-violet-200 dark:shadow-none p-3">
              <p *ngIf="message.message !== 'Thinking...'" class="text-xs text-white/90">{{ message.message }}</p>
              <div *ngIf="message.message === 'Thinking...'" class="flex items-center space-x-2">
                <svg class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span class="text-xs text-white/90">Thinking...</span>
              </div>
            </div>
          </div>

        </div>

      </div>

    </div>
    <!-- / Messages -->

  </div>

  <!-- Footer -->
  <div class="sticky bottom-0 w-full p-3">

    <button (click)="showMeetingAgenda()" [disabled]="this.loading" class="p-3 bg-violet-200/50 dark:bg-primary-300/25 rounded-md mb-3 w-full hover:opacity-90">

      <div class="mx-auto flex justify-between mb-1">
        <h4 class="text-sm text-secondary dark:text-primary-200 text-start font-semibold">Propose a meeting agenda</h4>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 text-secondary dark:text-primary-200">
          <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
        </svg>
      </div>
      <div class="flex justify-start">
        <span class="text-xs text-[#3c4377] dark:text-primary-200">to talk about the product you want to sell</span>
      </div>

    </button>

    <!-- Input -->
    <div class="flex items-center bg-white dark:bg-[#252c5f] rounded-md inset-shadow-sm w-full">
        <!-- Attach Button -->
        <!--
        <button class="p-3 pr-0 text-gray-500 dark:text-primary-200">
            <svg class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M15.621 4.379a3 3 0 00-4.242 0l-7 7a3 3 0 004.241 4.243h.001l.497-.5a.75.75 0 011.064 1.057l-.498.501-.002.002a4.5 4.5 0 01-6.364-6.364l7-7a4.5 4.5 0 016.368 6.36l-3.455 3.553A2.625 2.625 0 119.52 9.52l3.45-3.451a.75.75 0 111.061 1.06l-3.45 3.451a1.125 1.125 0 001.587 1.595l3.454-3.553a3 3 0 000-4.242z" clip-rule="evenodd" />
            </svg>
            <span class="sr-only">Attach a file</span>
        </button>
        -->

        <!-- Input Field -->
        <input type="text"
               [disabled]="this.loading" [(ngModel)]="prompt" [ngModelOptions]="{standalone: true}"  (keydown.enter)="askAIAssistant()"
               class="flex-1 items-center p-3 border-none focus:ring-0 text-sm text-secondary placeholder:text-sm placeholder-gray-400 dark:bg-[#252c5f] dark:placeholder-[bcc3ff] rounded-md"
               [placeholder]="loading ? 'Thinking...' : 'Send a message to the assistant'">

        <!-- Send Button -->
        <button (click)="askAIAssistant()" [disabled]="this.loading || !prompt || prompt.trim().length === 0" class="bg-transparent hover:opacity-75 p-3 disabled:opacity-75">
            <svg  viewBox="0 0 16 18" class="w-4 h-4 fill-[#fc8125]" fill="none">
                <path d="M15.3306 8.11622L1.46789 0.777129C0.801887 0.42454 0 0.907342 0 1.66092V6.23173C0 6.68478 0.304584 7.08123 0.742337 7.19797L7.5 9.00001L0.742338 10.8021C0.304584 10.9188 0 11.3152 0 11.7683V16.3391C0 17.0927 0.801886 17.5755 1.46789 17.2229L15.3306 9.8838C16.0401 9.50819 16.0401 8.49183 15.3306 8.11622Z" />
            </svg>
            <span class="sr-only">Send message</span>
        </button>
    </div>

  </div>
  <!-- / Footer -->

</div>
